import { useState, useEffect } from 'react';

const useSiteHeaderHeight = () => {
  const [menuHeight, setMenuHeight] = useState(0);

  useEffect(() => {
    const siteHeader = document.querySelector('.site-header') as HTMLDivElement;
    if (!siteHeader) return;

    const observer = new ResizeObserver(() => {
      setMenuHeight(siteHeader.offsetHeight);
    });

    observer.observe(siteHeader);

    return () => observer.disconnect();
  }, []);

  return menuHeight;
};

export default useSiteHeaderHeight;
